import { render, staticRenderFns } from "./ev5gtline-videopicstext-swiper.vue?vue&type=template&id=66192581&scoped=true"
import script from "./ev5gtline-videopicstext-swiper.vue?vue&type=script&lang=js"
export * from "./ev5gtline-videopicstext-swiper.vue?vue&type=script&lang=js"
import style0 from "./ev5gtline-videopicstext-swiper.vue?vue&type=style&index=0&id=66192581&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66192581",
  null
  
)

export default component.exports